import { render, staticRenderFns } from "./OfficeRoleForDepartment.vue?vue&type=template&id=2e33e2d1&scoped=true&"
import script from "./OfficeRoleForDepartment.vue?vue&type=script&lang=js&"
export * from "./OfficeRoleForDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e33e2d1",
  null
  
)

export default component.exports